import {fetchLabelTranslationApi, downloadCashRegisterApi} from '../services/common-api';

export const fetchLabelTranslation = (id) => {
    return fetchLabelTranslationApi(id);
}

export const downloadMonthlyIntakeBook = (contractCode, revenueDate) => {
    return downloadCashRegisterApi(contractCode, revenueDate, null);
}